var render = function () {
  var _ref;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [_vm.$style.container, (_ref = {}, _ref[_vm.$style.mobileStretch] = _vm.mobileStretch, _ref)]
  }, [_vm.$slots.hasOwnProperty('title') ? _c('div', {
    class: _vm.$style.title
  }, [_vm._t("title")], 2) : _vm._e(), _c('div', {
    directives: [{
      name: "scrollbar",
      rawName: "v-scrollbar",
      value: {
        id: "scrollbar-".concat(_vm.scrollbarId)
      },
      expression: "{ id: `scrollbar-${scrollbarId}` }"
    }],
    ref: "content",
    class: _vm.$style.content
  }, [_c('scrollbar-vertical', {
    class: _vm.$style.scrollbar,
    attrs: {
      "id": "scrollbar-".concat(_vm.scrollbarId)
    }
  }), _c('div', [_vm._t("content")], 2)], 1), _vm.isVisibleFooter ? _c('div', {
    class: _vm.$style.footer
  }, [_vm._t("footer", [_c('div', {
    class: [_vm.$style.action, _vm.$style.submit]
  }, [_vm._t("submit")], 2), _c('div', {
    class: [_vm.$style.action, _vm.$style.cancel]
  }, [_vm._t("cancel")], 2)])], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }